import React, { useState } from 'react';

const turnButtonStyle = {
  border: 'none',
  borderRadius: '999px',
  padding: '8px 18px',
  fontSize: '14px',
  lineHeight: '20px',
};

function RoleStateCard({
  className = '',
  title,
  badgeLabel,
  description,
  actionLabel,
  onActionClick,
  showAction = true,
  secondaryActionLabel,
  onSecondaryActionClick,
  showSecondaryAction = false,
  disabled = false,
  cardBackground = '#3E4856',
  cardBorderColor = '#374151',
  titleColor = '#FFFFFF',
  descriptionColor = '#FFFFFF',
  badgeBackground = '#EEEFF2',
  badgeTextColor = '#111827',
  actionBackground = '#E87623',
  actionTextColor = '#FFFFFF',
  secondaryActionBackground = '#F8F1EA',
  secondaryActionTextColor = '#E87623',
  iconSrc,
  titleInfoIconSrc,
  titleInfoTooltip,
  dataTestId,
}) {
  const [showTitleTooltip, setShowTitleTooltip] = useState(false);

  return (
    <div
      className={className}
      style={{
        flex: '1',
        minWidth: '280px',
        marginBottom: 0,
        padding: '18px 20px',
        minHeight: '154px',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '12px',
        border: cardBorderColor === 'transparent' ? 'none' : `1px solid ${cardBorderColor}`,
        backgroundColor: cardBackground,
        position: 'relative',
        overflow: 'visible',
      }}
      data-testid={dataTestId}
    >
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div className="d-flex align-items-center">
          <h5 className="mb-0" style={{ color: titleColor }}>
            {title}
          </h5>
          {titleInfoIconSrc ? (
            <button
              type="button"
              aria-label="Show title info"
              data-testid={`${dataTestId}-title-info`}
              onMouseEnter={() => setShowTitleTooltip(true)}
              onMouseLeave={() => setShowTitleTooltip(false)}
              onFocus={() => setShowTitleTooltip(true)}
              onBlur={() => setShowTitleTooltip(false)}
              onClick={() => setShowTitleTooltip((v) => !v)}
              style={{
                marginLeft: '8px',
                border: 'none',
                background: 'transparent',
                padding: 0,
                display: 'inline-flex',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <img
                src={titleInfoIconSrc}
                alt=""
                aria-hidden
                style={{ width: '16px', height: '16px' }}
              />
            </button>
          ) : null}
          {titleInfoTooltip && showTitleTooltip ? (
            <div
              role="tooltip"
              data-testid={`${dataTestId}-title-tooltip`}
              style={{
                position: 'absolute',
                top: '42px',
                left: '20px',
                maxWidth: '260px',
                zIndex: 4,
                background: '#111827',
                color: '#FFFFFF',
                borderRadius: '8px',
                padding: '8px 10px',
                fontSize: '12px',
                lineHeight: '16px',
                boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
              }}
            >
              {titleInfoTooltip}
            </div>
          ) : null}
        </div>
        <span
          style={{
            borderRadius: '6px',
            padding: '3px 10px',
            backgroundColor: badgeBackground,
            color: badgeTextColor,
            fontSize: '12px',
            lineHeight: '18px',
            fontWeight: 500,
          }}
        >
          {badgeLabel}
        </span>
      </div>
      <p
        style={{
          color: descriptionColor,
          fontSize: '14px',
          marginBottom: showAction || showSecondaryAction ? '12px' : 0,
          maxWidth: '75%',
          lineHeight: '1.4',
          flex: '1 1 auto',
        }}
      >
        {description}
      </p>
      {showAction || showSecondaryAction ? (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
            alignSelf: 'flex-start',
            marginTop: 'auto',
          }}
        >
          {showAction ? (
            <button
              type="button"
              onClick={onActionClick}
              disabled={disabled}
              data-testid={dataTestId ? `${dataTestId}-primary-action` : undefined}
              style={{
                ...turnButtonStyle,
                backgroundColor: actionBackground,
                color: actionTextColor,
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.7 : 1,
              }}
            >
              {actionLabel}
            </button>
          ) : null}
          {showSecondaryAction ? (
            <button
              type="button"
              onClick={onSecondaryActionClick}
              disabled={disabled}
              data-testid={dataTestId ? `${dataTestId}-secondary-action` : undefined}
              style={{
                ...turnButtonStyle,
                backgroundColor: secondaryActionBackground,
                color: secondaryActionTextColor,
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.7 : 1,
              }}
            >
              {secondaryActionLabel}
            </button>
          ) : null}
        </div>
      ) : null}
      {iconSrc ? (
        <img
          src={iconSrc}
          alt=""
          aria-hidden
          style={{
            position: 'absolute',
            right: '8px',
            bottom: '-2px',
            width: '86px',
            opacity: 0.55,
            pointerEvents: 'none',
          }}
        />
      ) : null}
    </div>
  );
}

export default RoleStateCard;
